unit View.Plano_Contas1.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewPlano_Contas1List = class(TForm)
    btNew: TButton;
    Plano_Contas1Dataset: TXDataWebDataSet;
    Plano_Contas1Datasetid: TIntegerField;
    Plano_Contas1Datasetaliado_id: TIntegerField;
    Plano_Contas1Datasetdata_base_id: TIntegerField;
    Plano_Contas1Datasetnome: TStringField;
    Plano_Contas1Datasetclasse: TStringField;
    Plano_Contas1Datasetpeso_ideal: TFloatField;
    Plano_Contas1Datasetcodigo_interno: TIntegerField;
    Plano_Contas1Datasetexcluido: TBooleanField;
    Plano_Contas1Datasetinclusao: TDateTimeField;
    Plano_Contas1Datasetalteracao: TDateTimeField;
    Plano_Contas1Datasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewPlano_Contas1List: TFViewPlano_Contas1List;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPlano_Contas1List }

procedure TFViewPlano_Contas1List.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewPlano_Contas1List.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPlano_Contas1List(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewPlano_Contas1List, AElementID, Result, @AfterCreate);
end;

procedure TFViewPlano_Contas1List.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewPlano_Contas1List.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewPlano_Contas1List.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Plano_Contas1Dataset.Connection.Model.DefaultSchema.FindEntityType(Plano_Contas1Dataset.EntitySetName),
      Plano_Contas1Dataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewPlano_Contas1List.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('plano_contas1', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetValorDicionarioClasses('plano_contas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_plano_contas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Plano_Contas1Dataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewPlano_Contas1List.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.plano_contas1.list.pagination.info');
  btNew := TButton.Create('view.plano_contas1.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.plano_contas1.list.table');
  cbPageSize := TComboBox.Create('view.plano_contas1.list.cbPageSize');
  edSearch := TEdit.Create('view.plano_contas1.list.search');
  lcPaginator := TListControl.Create('view.plano_contas1.list.pagination');
  Plano_Contas1Dataset := TXDataWebDataSet.Create(Self);
  Plano_Contas1Datasetid := TIntegerField.Create(Self);
  Plano_Contas1Datasetaliado_id := TIntegerField.Create(Self);
  Plano_Contas1Datasetdata_base_id := TIntegerField.Create(Self);
  Plano_Contas1Datasetnome := TStringField.Create(Self);
  Plano_Contas1Datasetclasse := TStringField.Create(Self);
  Plano_Contas1Datasetpeso_ideal := TFloatField.Create(Self);
  Plano_Contas1Datasetcodigo_interno := TIntegerField.Create(Self);
  Plano_Contas1Datasetexcluido := TBooleanField.Create(Self);
  Plano_Contas1Datasetinclusao := TDateTimeField.Create(Self);
  Plano_Contas1Datasetalteracao := TDateTimeField.Create(Self);
  Plano_Contas1Datasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Plano_Contas1Dataset.BeforeLoadDFMValues;
  Plano_Contas1Datasetid.BeforeLoadDFMValues;
  Plano_Contas1Datasetaliado_id.BeforeLoadDFMValues;
  Plano_Contas1Datasetdata_base_id.BeforeLoadDFMValues;
  Plano_Contas1Datasetnome.BeforeLoadDFMValues;
  Plano_Contas1Datasetclasse.BeforeLoadDFMValues;
  Plano_Contas1Datasetpeso_ideal.BeforeLoadDFMValues;
  Plano_Contas1Datasetcodigo_interno.BeforeLoadDFMValues;
  Plano_Contas1Datasetexcluido.BeforeLoadDFMValues;
  Plano_Contas1Datasetinclusao.BeforeLoadDFMValues;
  Plano_Contas1Datasetalteracao.BeforeLoadDFMValues;
  Plano_Contas1Datasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewPlano_Contas1List';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'classe';
      Title := 'classe';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'peso_ideal';
      Title := 'peso_ideal';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Plano_Contas1Dataset.SetParentComponent(Self);
    Plano_Contas1Dataset.Name := 'Plano_Contas1Dataset';
    Plano_Contas1Dataset.EntitySetName := 'Plano_Contas1';
    Plano_Contas1Dataset.Connection := DMConnection.ApiConnection;
    Plano_Contas1Dataset.Left := 72;
    Plano_Contas1Dataset.Top := 144;
    Plano_Contas1Datasetid.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetid.Name := 'Plano_Contas1Datasetid';
    Plano_Contas1Datasetid.FieldName := 'id';
    Plano_Contas1Datasetid.Required := True;
    Plano_Contas1Datasetaliado_id.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetaliado_id.Name := 'Plano_Contas1Datasetaliado_id';
    Plano_Contas1Datasetaliado_id.FieldName := 'aliado_id';
    Plano_Contas1Datasetaliado_id.Required := True;
    Plano_Contas1Datasetdata_base_id.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetdata_base_id.Name := 'Plano_Contas1Datasetdata_base_id';
    Plano_Contas1Datasetdata_base_id.FieldName := 'data_base_id';
    Plano_Contas1Datasetdata_base_id.Required := True;
    Plano_Contas1Datasetnome.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetnome.Name := 'Plano_Contas1Datasetnome';
    Plano_Contas1Datasetnome.FieldName := 'nome';
    Plano_Contas1Datasetnome.Required := True;
    Plano_Contas1Datasetnome.Size := 255;
    Plano_Contas1Datasetclasse.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetclasse.Name := 'Plano_Contas1Datasetclasse';
    Plano_Contas1Datasetclasse.FieldName := 'classe';
    Plano_Contas1Datasetclasse.Size := 255;
    Plano_Contas1Datasetpeso_ideal.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetpeso_ideal.Name := 'Plano_Contas1Datasetpeso_ideal';
    Plano_Contas1Datasetpeso_ideal.FieldName := 'peso_ideal';
    Plano_Contas1Datasetcodigo_interno.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetcodigo_interno.Name := 'Plano_Contas1Datasetcodigo_interno';
    Plano_Contas1Datasetcodigo_interno.FieldName := 'codigo_interno';
    Plano_Contas1Datasetcodigo_interno.Required := True;
    Plano_Contas1Datasetexcluido.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetexcluido.Name := 'Plano_Contas1Datasetexcluido';
    Plano_Contas1Datasetexcluido.FieldName := 'excluido';
    Plano_Contas1Datasetinclusao.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetinclusao.Name := 'Plano_Contas1Datasetinclusao';
    Plano_Contas1Datasetinclusao.FieldName := 'inclusao';
    Plano_Contas1Datasetalteracao.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetalteracao.Name := 'Plano_Contas1Datasetalteracao';
    Plano_Contas1Datasetalteracao.FieldName := 'alteracao';
    Plano_Contas1Datasetexclusao.SetParentComponent(Plano_Contas1Dataset);
    Plano_Contas1Datasetexclusao.Name := 'Plano_Contas1Datasetexclusao';
    Plano_Contas1Datasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Plano_Contas1Dataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Plano_Contas1Dataset.AfterLoadDFMValues;
    Plano_Contas1Datasetid.AfterLoadDFMValues;
    Plano_Contas1Datasetaliado_id.AfterLoadDFMValues;
    Plano_Contas1Datasetdata_base_id.AfterLoadDFMValues;
    Plano_Contas1Datasetnome.AfterLoadDFMValues;
    Plano_Contas1Datasetclasse.AfterLoadDFMValues;
    Plano_Contas1Datasetpeso_ideal.AfterLoadDFMValues;
    Plano_Contas1Datasetcodigo_interno.AfterLoadDFMValues;
    Plano_Contas1Datasetexcluido.AfterLoadDFMValues;
    Plano_Contas1Datasetinclusao.AfterLoadDFMValues;
    Plano_Contas1Datasetalteracao.AfterLoadDFMValues;
    Plano_Contas1Datasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
